const options = [
  { value: "Computer Science & Engineering", label: "Computer Science & Engineering" },
  { value: "Chemical Engineering", label: "Chemical Engineering" },
  { value: "Civil Engineering", label: "Civil Engineering" },
  { value: "Electrical Engineering", label: "Electrical Engineering" },
  { value: "Mechanical Engineering", label: "Mechanical Engineering" },
  { value: "Art, Media and Performance", label: "Art, Media and Performance" },
  { value: "Design", label: "Design" },
  { value: "Economics", label: "Economics" },
  { value: "English", label: "English" },
  { value: "History and Archaeology", label: "History and Archaeology" },
  { value: "International Relations and Governance Studies", label: "International Relations and Governance Studies" },
  { value: "Sociology", label: "Sociology" },
  { value: "Decision Sciences, Operations Management, and Information Systems", label: "Decision Sciences, Operations Management, and Information Systems" },
  { value: "Economics and Public Policy", label: "Economics and Public Policy" },
  { value: "Finance, Accounting and Control", label: "Finance, Accounting and Control" },
  { value: "General Management", label: "General Management" },
  { value: "Marketing Management", label: "Marketing Management" },
  { value: "Organization Behavior and Human Resource Management", label: "Organization Behavior and Human Resource Management" },
  { value: "Strategy and Entrepreneurship", label: "Strategy and Entrepreneurship" },
  { value: "Chemistry", label: "Chemistry" },
  { value: "Life Sciences", label: "Life Sciences" },
  { value: "Mathematics", label: "Mathematics" },
  { value: "Physics", label: "Physics" },
  { value: "HTML", label: "HTML" },
  { value: "CSS", label: "CSS" },
  { value: "JavaScript", label: "JavaScript" },
  { value: "UI/UX Design", label: "UI/UX Design" },
  { value: "React", label: "React" },
  { value: "Machine Learning", label: "Machine Learning" },
  { value: "Scrum", label: "Scrum" },
  { value: "NumPy", label: "NumPy" },
  { value: "Python", label: "Python" },
  { value: "Go", label: "Go" },
  { value: "NodeJS", label: "NodeJS" },
  { value: "JavaFX", label: "JavaFX" },
  { value: "Java", label: "Java" },
  { value: "Microsoft Excel", label: "Microsoft Excel" },
  { value: "Microsoft Outlook", label: "Microsoft Outlook" },
  { value: "Microsoft Word", label: "Microsoft Word" },
  { value: "Robot Framework", label: "Robot Framework" },
  { value: "Scaled Agile Framework", label: "Scaled Agile Framework" },
  { value: "Spring framework", label: "Spring framework" },
  { value: "Git", label: "Git" },
  { value: "Docker", label: "Docker" },
  { value: "Redis", label: "Redis" },
  { value: "Jira", label: "Jira" },
  { value: "Commercial Awareness", label: "Commercial Awareness" },
  { value: "Conflict resolution", label: "Conflict resolution" },
  { value: "Test-driven development", label: "Test-driven development" },
  { value: "Negotiation", label: "Negotiation" },
  { value: "Networking", label: "Networking" },
  { value: "Change Management", label: "Change Management" },
  { value: "Stakeholder Engagement", label: "Stakeholder Engagement" },
  { value: "Problem-Solving", label: "Problem-Solving" },
  { value: "Project Coordination", label: "Project Coordination" },
  { value: "Search Engine Optimization", label: "Search Engine Optimization" },
  { value: "Consulting", label: "Consulting" },
  { value: "Coaching", label: "Coaching" },
  { value: "Photoshop", label: "Photoshop" },
  { value: "Introduction To PostgreSQL", label: "Introduction To PostgreSQL" },
  { value: "C#", label: "C#" },
  { value: "C++", label: "C++" },
  { value: "PHP", label: "PHP" },
  { value: "OpenCV", label: "OpenCV" },
  { value: "MongoDB", label: "MongoDB" },
  { value: "DBMS", label: "DBMS" },
  { value: "Data Analytics", label: "Data Analytics" },
  { value: "Data Structures", label: "Data Structures" },
  { value: "Data Mining", label: "Data Mining" },
  { value: "Data Science", label: "Data Science" },
  { value: "Data Visualization", label: "Data Visualization" },
  { value: "Data Warehousing", label: "Data Warehousing" },
  { value: "Data Modeling", label: "Data Modeling" },
  { value: "Data Management", label: "Data Management" },
  { value: "Data Analysis", label: "Data Analysis" },
  { value: "Next.js", label: "Next.js" },
  { value: "Angular", label: "Angular" },
  { value: "Vue.js", label: "Vue.js" },
  { value: "Django", label: "Django" },
  { value: "Flask", label: "Flask" },
  { value: "Ruby on Rails", label: "Ruby on Rails" },
  { value: "Laravel", label: "Laravel" },
  { value: "ASP.NET", label: "ASP.NET" },
  { value: "Docker", label: "Docker" },
  { value: "Kubernetes", label: "Kubernetes" },
  { value: "AWS", label: "AWS" },
  { value: "Azure", label: "Azure" },
  { value: "Google Cloud", label: "Google Cloud" },
  { value: "Firebase", label: "Firebase" },
  { value: "Heroku", label: "Heroku" },
  { value: "MongoDB", label: "MongoDB" },
  { value: "MySQL", label: "MySQL" },
  { value: "PostgreSQL", label: "PostgreSQL" },
  { value: "SQLite", label: "SQLite" },
  { value: "Redis", label: "Redis" },
  { value: "GraphQL", label: "GraphQL" },
  { value: "REST", label: "REST" },
  { value: "Git", label: "Git" },
  { value: "Scrum", label: "Scrum" },
  { value: "Kanban", label: "Kanban" },
  { value: "Agile", label: "Agile" },
  
];

// const options1= [
//     { value: "Computer Science and Engineering", label: "Computer Science and Engineering" },
// ]

// //console.log(options[0].label)

export default options;

// export default options1;